import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/dashboard/Dashboard';
// import Admin from './pages/admin/Admin';
import Accounts from './pages/admin/Accounts';
import AdminInvestments from './pages/admin/Investments';
import Notifications from './pages/admin/Notifications';
import Tickets from './pages/admin/Tickets';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
// import AuthForm from './pages/auth/AuthForm';
import Home from './pages/home/index';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
// import ClientDashboard from './components/ClientDashboard';
// import AdminDashboard from './components/AdminDashboard';
import Investments from './pages/dashboard/Investments';
import Investment from './pages/admin/Investment';
import Milestones from './pages/dashboard/Milestones';
import ViewContract from './pages/dashboard/ViewContract';
import Support from './pages/dashboard/Support';
import Setting from './pages/dashboard/Setting';
import Referral from './pages/dashboard/Referral';
import Waiting from './pages/investment/Waiting';
import TicketChatPage from './pages/dashboard/TicketChatPage';
import StartInvesting from './pages/investment/StartInvesting';
import WireTransferPage from './pages/investment/WireTransferPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminSetting from './pages/admin/Settings';
import ReviewSign from './pages/admin/ReviewSign';
import Thankyou from './pages/investment/Thankyou';
import Whatsnext from './pages/investment/What\'snext';
import ReferralLink from './pages/dashboard/ReferralLink';
import EditContractTemplate from './pages/admin/EditContractTemplate';


function App() {
  return (
    <>
      <Router>
        <Routes>
        <Route path="/:userName/:referrallink" element={<ReferralLink />} />
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/admin" element={<AdminDashboard />}>
            <Route path='settings' element={<AdminSetting />} />
            <Route path='edit-contract-template' element={<EditContractTemplate />} />
            <Route path="accounts" element={<Accounts />} />
            <Route path="accounts/:id" element={<Accounts />} />
            <Route path="investments" element={<AdminInvestments />} />
            <Route path='investments/:id' element={<Investment />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="tickets/:id" element={<Tickets />} />
            <Route index element={<Accounts />} />
          </Route>
          <Route path="/admin/review-sign/:id" element={<ProtectedRoute adminOnly={true}><ReviewSign /></ProtectedRoute>} />
          <Route
            path="/investments"
            element={
              <ProtectedRoute>
                <Investments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/milestones"
            element={
              <ProtectedRoute>
                <Milestones />
              </ProtectedRoute>
            }
          />
          <Route
            path="/view-contract/:id"
            element={
              <ProtectedRoute>
                <ViewContract />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedRoute>
                <Support />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support/tickets/:id"
            element={
              <ProtectedRoute>
                <TicketChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/start-investing"
            element={
              <ProtectedRoute>
                <StartInvesting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/waiting"
            element={
              <ProtectedRoute>
                <Waiting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/start-investing/waiting"
            element={
              <ProtectedRoute>
                <Thankyou />
              </ProtectedRoute>
            }
          />
          <Route
            path="/start-investing/whta'snext"
            element={
              <ProtectedRoute>
                <Whatsnext />
              </ProtectedRoute>
            }
          />
          <Route
            path='/start-investing/wire-transfer/:id'
            element={
              <ProtectedRoute>
                <WireTransferPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Setting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/referral"
            element={
              <ProtectedRoute>
                <Referral />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;